if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      quantityInput = undefined;
      quantityForm = undefined;
      onVariantChangeUnsubscriber = undefined;
      cartUpdateUnsubscriber = undefined;
      abortController = undefined;
      pendingRequestUrl = null;
      preProcessHtmlCallbacks = [];
      postProcessHtmlCallbacks = [];

      constructor() {
        super();

        this.quantityInput = this.querySelector('.quantity__input');
        this.expandColors();
      }

      connectedCallback() {
        this.initializeProductSwapUtility();

        this.onVariantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.optionValueSelectionChange,
          this.handleOptionValueChange.bind(this),
        );

        this.initQuantityHandlers();
        this.dispatchEvent(
          new CustomEvent('product-info:loaded', {bubbles: true}),
        );
      }

      expandColors() {
        this.colorExpanders = this.querySelectorAll(
          '.category-product-expand-action',
        );
        this.colorExpanders.forEach((expander) => {
          expander.addEventListener('click', () => {
            var category = expander.dataset.category;
            var categoryProducts = this.querySelectorAll(
              `[data-category-item="${category}"]`,
            );
            categoryProducts.forEach((product) => {
              product.classList.remove('hidden');
            });
            expander.classList.add('hidden');
          });
        });
      }

      addPreProcessCallback(callback) {
        this.preProcessHtmlCallbacks.push(callback);
      }

      initQuantityHandlers() {
        if (!this.quantityInput) return;

        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;

        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(
            PUB_SUB_EVENTS.cartUpdate,
            this.fetchQuantityRules.bind(this),
          );
        }
      }

      disconnectedCallback() {
        this.onVariantChangeUnsubscriber();
        this.cartUpdateUnsubscriber?.();
      }

      initializeProductSwapUtility() {
        this.preProcessHtmlCallbacks.push((html) =>
          html
            .querySelectorAll('.scroll-trigger')
            .forEach((element) =>
              element.classList.add('scroll-trigger--cancel'),
            ),
        );
        this.postProcessHtmlCallbacks.push((newNode) => {
          window?.Shopify?.PaymentButton?.init();
          window?.ProductModel?.loadShopifyXR();
        });
      }

      handleOptionValueChange({data: {event, target, selectedOptionValues}}) {
        if (!this.contains(event.target)) return;

        this.resetProductFormState();

        var productUrl =
          target.dataset.productUrl ||
          this.pendingRequestUrl ||
          this.dataset.url;
        this.pendingRequestUrl = productUrl;
        var shouldSwapProduct = this.dataset.url !== productUrl;
        var shouldFetchFullPage =
          this.dataset.updateUrl === 'true' && shouldSwapProduct;
        var badgeSoldout = document.querySelector('.badge-soldout');
        if(badgeSoldout != null){
          target.classList.contains('disabled')
          ? badgeSoldout.classList.remove('hidden')
          : badgeSoldout.classList.add('hidden');
        }

        clearTimeout(this._renderTimeout);
        this._renderTimeout = setTimeout(() => {
          this.renderProductInfo({
            requestUrl: this.buildRequestUrlWithParams(
              productUrl,
              selectedOptionValues,
              shouldFetchFullPage,
            ),
            targetId: target.id,
            callback: shouldSwapProduct
              ? this.handleSwapProduct(productUrl, shouldFetchFullPage)
              : this.handleUpdateProductInfo(productUrl),
          });
        }, 120);
      }

      resetProductFormState() {
        var productForm = this.productForm;
        //productForm?.toggleSubmitButton(true);
        productForm?.handleErrorMessage();
      }

      handleSwapProduct(productUrl, updateFullPage) {
        return (html) => {
          this.productModal?.remove();

          var selector = updateFullPage
            ? "product-info[id^='MainProduct']"
            : 'product-info';
          var variant = this.getSelectedVariant(html.querySelector(selector));
          this.updateURL(productUrl, variant?.id);

          if (updateFullPage) {
            document.querySelector('head title').innerHTML =
              html.querySelector('head title').innerHTML;

            HTMLUpdateUtility.viewTransition(
              document.querySelector('main'),
              html.querySelector('main'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks,
            );
          } else {
            HTMLUpdateUtility.viewTransition(
              this,
              html.querySelector('product-info'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks,
            );
          }
        };
      }

      renderProductInfo({requestUrl, targetId, callback}) {
        this.abortController?.abort();
        this.abortController = new AbortController();

        fetch(requestUrl, {signal: this.abortController.signal})
          .then((response) => {
            if (!response.ok) throw new Error(`HTTP ${response.status}`);
            return response.text();
          })
          .then((responseText) => {
            this.pendingRequestUrl = null;
            var html = new DOMParser().parseFromString(
              responseText,
              'text/html',
            );
            callback(html);
          })
          .then(() => {
            // set focus to last clicked option value
            document.querySelector(`#${targetId}`)?.focus();
          })
          .catch((error) => {
            if (error.name === 'AbortError') {
              console.log('Fetch aborted by user');
            } else {
              console.error(error);
            }
          });
      }

      getSelectedVariant(productInfoNode) {
        var selectedVariant = productInfoNode.querySelector(
          'variant-selects [data-selected-variant]',
        )?.innerHTML;
        return !!selectedVariant ? JSON.parse(selectedVariant) : null;
      }

      buildRequestUrlWithParams(
        url,
        optionValues,
        shouldFetchFullPage = false,
      ) {
        var params = [];

        !shouldFetchFullPage && params.push(`section_id=${this.sectionId}`);

        if (optionValues.length) {
          params.push(`option_values=${optionValues.join(',')}`);
        }

        return `${url}?${params.join('&')}`;
      }

      updateOptionValues(html) {
        var variantSelects = html.querySelector('variant-selects');
        if (variantSelects) {
          HTMLUpdateUtility.viewTransition(
            this.variantSelectors,
            variantSelects,
            this.preProcessHtmlCallbacks,
          );
        }
      }

      handleUpdateProductInfo(productUrl) {
        return (html) => {
          var variant = this.getSelectedVariant(html);

          this.pickupAvailability?.update(variant);
          this.updateOptionValues(html);
          this.updateURL(productUrl, variant?.id);
          this.updateVariantInputs(variant?.id);

          //console.log('abcde', variant);
          if (variant?.available) {
            document
              .querySelector('.product-notify-with-similar')
              ?.classList.add('hidden');
            this.querySelectorAll('.product-form__submit').forEach(
              (element) => {
                element?.classList.remove('hidden');
              },
            );
          } else {
            document
              .querySelector('.product-notify-with-similar')
              ?.classList.remove('hidden');
            this.querySelectorAll('.product-form__submit').forEach(
              (element) => {
                element?.classList.add('hidden');
              },
            );
          }
          if (!variant) {
            this.setUnavailable();
            return;
          }

          this.updateMedia(html, variant?.featured_media?.id);

          var updateSourceFromDestination = (
            id,
            shouldHide = (source) => false,
          ) => {
            if (id === 'price') {
              var source = html.getElementById(`${id}-${this.sectionId}`);
              var destination = document.querySelectorAll(
                '.product-info-price',
              );
              if (source && destination.length > 0) {
                destination.forEach((element) => {
                  element.innerHTML = source.innerHTML;
                  element.classList.toggle('hidden', shouldHide(source));
                });
              }
            } else if (id === 'installments_text') {
              var source = html.getElementById(`${id}-${this.sectionId}`);
              var destination =
                document.querySelectorAll('.installments_text');
              if (source && destination.length > 0) {
                destination.forEach((element) => {
                  element.innerHTML = source.innerHTML;
                  element.classList.toggle('hidden', shouldHide(source));
                });
              }
            } else {
              var source = html.getElementById(`${id}-${this.sectionId}`);
              var destination = this.querySelector(
                `#${id}-${this.dataset.section}`,
              );
              if (source && destination) {
                destination.innerHTML = source.innerHTML;
                destination.classList.toggle('hidden', shouldHide(source));
              }
            }
          };

          updateSourceFromDestination('price');
          updateSourceFromDestination('installments_text');
          updateSourceFromDestination('Sku', ({classList}) =>
            classList.contains('hidden'),
          );
          updateSourceFromDestination(
            'Inventory',
            ({innerText}) => innerText === '',
          );
          updateSourceFromDestination('Volume');
          updateSourceFromDestination('Price-Per-Item', ({classList}) =>
            classList.contains('hidden'),
          );

          this.updateQuantityRules(this.sectionId, html);
          this.querySelector(
            `#Quantity-Rules-${this.dataset.section}`,
          )?.classList.remove('hidden');
          this.querySelector(
            `#Volume-Note-${this.dataset.section}`,
          )?.classList.remove('hidden');

          // this.productForm?.toggleSubmitButton(
          //   html
          //     .getElementById(`ProductSubmitButton-${this.sectionId}`)
          //     ?.hasAttribute('disabled') ?? true,
          //   window.variantStrings.soldOut,
          // );

          var stickyAddToCartButton = document.querySelector(
            '.sticky-add-to-cart',
          );
          //console.log(stickyAddToCartButton);
          if (stickyAddToCartButton) {
            var isDisabled =
              html
                .getElementById(`ProductSubmitButton-${this.sectionId}`)
                ?.hasAttribute('disabled') ?? true;
            var isPreOrder =  html
            .getElementById(`ProductSubmitButton-${this.sectionId}`)
            ?.classList.contains('product-pre-order') ?? true;

            if (isDisabled) {
              var stickySelect = document.querySelector('.sticky-select');
              if (isPreOrder) {
                const acceptsInput = document.querySelector('#accepts_pre_order_product');
                stickyAddToCartButton.classList.remove('hidden');
                if (acceptsInput ) {
                  if (acceptsInput.checked) {
                    stickyAddToCartButton.removeAttribute('disabled')
                  } else {
                    stickyAddToCartButton.disabled = true;
                  }
                } 
                
                if (stickySelect) {
                  stickySelect.classList.add('hide');
                }
              } else {
                stickyAddToCartButton.classList.add('hidden');
                if (stickySelect) {
                  stickySelect.classList.remove('hide');
                  stickySelect.classList.remove('show');
                  stickySelect.querySelector('span').textContent =
                    window.variantStrings.notify_me;
                }
              }
              
            } else {
              stickyAddToCartButton.classList.remove('hidden');
              stickyAddToCartButton.disabled = false;
            }
            stickyAddToCartButton.querySelector('span').textContent = isDisabled
              ? isPreOrder ? window.variantStrings.preOrder :
                            window.variantStrings.soldOut
              : window.variantStrings.addToBag;

            stickyAddToCartButton.setAttribute(
              'aria-label',
              isDisabled
                ? isPreOrder ? window.variantStrings.preOrder :
                              window.variantStrings.soldOut
                : window.variantStrings.addToBag,
            );
          }

          publish(PUB_SUB_EVENTS.variantChange, {
            data: {
              sectionId: this.sectionId,
              html,
              variant,
            },
          });
        };
      }

      updateVariantInputs(variantId) {
        this.querySelectorAll(
          `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`,
        ).forEach((productForm) => {
          var input = productForm.querySelector('input[name="id"]');
          input.value = variantId ?? '';
          input.dispatchEvent(new Event('change', {bubbles: true}));
        });
      }

      updateURL(url, variantId) {
        this.querySelector('share-button')?.updateUrl(
          `${window.shopUrl}${url}${variantId ? `?variant=${variantId}` : ''}`,
        );

        if (this.dataset.updateUrl === 'false') return;
        window.history.replaceState(
          {},
          '',
          `${url}${variantId ? `?variant=${variantId}` : ''}`,
        );
      }

      setUnavailable() {
        // this.productForm?.toggleSubmitButton(
        //   true,
        //   window.variantStrings.unavailable,
        // );

        var selectors = [
          'price',
          'Inventory',
          'Sku',
          'Price-Per-Item',
          'Volume-Note',
          'Volume',
          'Quantity-Rules',
        ]
          .map((id) => `#${id}-${this.dataset.section}`)
          .join(', ');
        document
          .querySelectorAll(selectors)
          .forEach(({classList}) => classList.add('hidden'));
      }

      updateMedia(html, variantFeaturedMediaId) {
        if (!variantFeaturedMediaId) return;

        var mediaGallerySource = this.querySelector('media-gallery ul');
        var mediaGalleryDestination = html.querySelector(`media-gallery ul`);

        var refreshSourceData = () => {
          if (this.hasAttribute('data-zoom-on-hover')) enableZoomOnHover(2);
          var mediaGallerySourceItems = Array.from(
            mediaGallerySource.querySelectorAll('li[data-media-id]'),
          );
          var sourceSet = new Set(
            mediaGallerySourceItems.map((item) => item.dataset.mediaId),
          );
          var sourceMap = new Map(
            mediaGallerySourceItems.map((item, index) => [
              item.dataset.mediaId,
              {item, index},
            ]),
          );
          return [mediaGallerySourceItems, sourceSet, sourceMap];
        };

        if (mediaGallerySource && mediaGalleryDestination) {
          let [mediaGallerySourceItems, sourceSet, sourceMap] =
            refreshSourceData();
          var mediaGalleryDestinationItems = Array.from(
            mediaGalleryDestination.querySelectorAll('li[data-media-id]'),
          );
          var destinationSet = new Set(
            mediaGalleryDestinationItems.map(({dataset}) => dataset.mediaId),
          );
          let shouldRefresh = false;

          // add items from new data not present in DOM
          for (let i = mediaGalleryDestinationItems.length - 1; i >= 0; i--) {
            if (
              !sourceSet.has(mediaGalleryDestinationItems[i].dataset.mediaId)
            ) {
              mediaGallerySource.prepend(mediaGalleryDestinationItems[i]);
              shouldRefresh = true;
            }
          }

          // remove items from DOM not present in new data
          for (let i = 0; i < mediaGallerySourceItems.length; i++) {
            if (
              !destinationSet.has(mediaGallerySourceItems[i].dataset.mediaId)
            ) {
              mediaGallerySourceItems[i].remove();
              shouldRefresh = true;
            }
          }

          // refresh
          if (shouldRefresh)
            [mediaGallerySourceItems, sourceSet, sourceMap] =
              refreshSourceData();

          // if media galleries don't match, sort to match new data order
          mediaGalleryDestinationItems.forEach(
            (destinationItem, destinationIndex) => {
              var sourceData = sourceMap.get(destinationItem.dataset.mediaId);

              if (sourceData && sourceData.index !== destinationIndex) {
                mediaGallerySource.insertBefore(
                  sourceData.item,
                  mediaGallerySource.querySelector(
                    `li:nth-of-type(${destinationIndex + 1})`,
                  ),
                );

                // refresh source now that it has been modified
                [mediaGallerySourceItems, sourceSet, sourceMap] =
                  refreshSourceData();
              }
            },
          );
        }

        // set featured media as active in the media gallery
        this.querySelector(`media-gallery`)?.setActiveMedia?.(
          `${this.dataset.section}-${variantFeaturedMediaId}`,
          true,
        );

        // update media modal
        var modalContent = this.productModal?.querySelector(
          `.product-media-modal__content`,
        );
        var newModalContent = html.querySelector(
          `product-modal .product-media-modal__content`,
        );
        if (modalContent && newModalContent)
          modalContent.innerHTML = newModalContent.innerHTML;
      }

      setQuantityBoundries() {
        var data = {
          cartQuantity: this.quantityInput.dataset.cartQuantity
            ? parseInt(this.quantityInput.dataset.cartQuantity)
            : 0,
          min: this.quantityInput.dataset.min
            ? parseInt(this.quantityInput.dataset.min)
            : 1,
          max: this.quantityInput.dataset.max
            ? parseInt(this.quantityInput.dataset.max)
            : null,
          step: this.quantityInput.step ? parseInt(this.quantityInput.step) : 1,
        };

        let min = data.min;
        var max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.quantityInput.min = min;

        if (max) {
          this.quantityInput.max = max;
        } else {
          this.quantityInput.removeAttribute('max');
        }
        this.quantityInput.value = min;

        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        var currentVariantId = this.productForm?.variantIdInput?.value;
        if (!currentVariantId) return;

        this.querySelector(
          '.quantity__rules-cart .loading__spinner',
        ).classList.remove('hidden');
        fetch(
          `${this.dataset.url}?variant=${currentVariantId}&section_id=${this.dataset.section}`,
        )
          .then((response) => response.text())
          .then((responseText) => {
            var html = new DOMParser().parseFromString(
              responseText,
              'text/html',
            );
            this.updateQuantityRules(this.dataset.section, html);
          })
          .catch((e) => console.error(e))
          .finally(() =>
            this.querySelector(
              '.quantity__rules-cart .loading__spinner',
            ).classList.add('hidden'),
          );
      }

      updateQuantityRules(sectionId, html) {
        if (!this.quantityInput) return;
        this.setQuantityBoundries();

        var quantityFormUpdated = html.getElementById(
          `Quantity-Form-${sectionId}`,
        );
        var selectors = [
          '.quantity__input',
          '.quantity__rules',
          '.quantity__label',
        ];
        for (let selector of selectors) {
          var current = this.quantityForm.querySelector(selector);
          var updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.quantity__input') {
            var attributes = [
              'data-cart-quantity',
              'data-min',
              'data-max',
              'step',
            ];
            for (let attribute of attributes) {
              var valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) {
                current.setAttribute(attribute, valueUpdated);
              } else {
                current.removeAttribute(attribute);
              }
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }

      get productForm() {
        return this.querySelector(`product-form`);
      }

      get productModal() {
        return document.querySelector(`#ProductModal-${this.dataset.section}`);
      }

      get pickupAvailability() {
        return this.querySelector(`pickup-availability`);
      }

      get variantSelectors() {
        return this.querySelector('variant-selects');
      }

      get relatedProducts() {
        var relatedProductsSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'related-products',
        );
        return document.querySelector(
          `product-recommendations[data-section-id^="${relatedProductsSectionId}"]`,
        );
      }

      get quickOrderList() {
        var quickOrderListSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'quick_order_list',
        );
        return document.querySelector(
          `quick-order-list[data-id^="${quickOrderListSectionId}"]`,
        );
      }

      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }
    },
  );
}

// document.addEventListener('DOMContentLoaded', () => {
  // Get URL parameters
  var urlParams = new URLSearchParams(window.location.search);
  var variantId = urlParams.get('variant');

  // Deselect all original radio buttons if no variant is provided
  if (!variantId) {
    var radioButtons = document.querySelectorAll(
      '.full-width-main-product .original-radios [type="radio"]',
    );
    radioButtons.forEach((radio) => {
      radio.checked = false;
      radio.dispatchEvent(new Event('change')); // Trigger change event if needed
    });
  }

  // Cache selectors for better performance
  var customRadios = document.querySelectorAll(
    '.full-width-main-product .custom-radios [type="radio"] + label',
  );
  var originalRadios = document.querySelectorAll(
    '.full-width-main-product .original-radios [type="radio"]',
  );
  var numberOfOptions = document.querySelectorAll(
    '.full-width-main-product .product-form__input:not([hidden])',
  ).length;

  // Attach click event listeners to custom radio labels
  customRadios.forEach((label) => {
    label.addEventListener('click', (e) => {
      var selectedOptionVal = e.target.getAttribute('data-value');
      if (!selectedOptionVal) return;

      // Select the corresponding custom radio
      var customRadio = document.querySelector(
        `.full-width-main-product .custom-radios [type="radio"][value="${selectedOptionVal}"]`,
      );
      if (customRadio) {
        // Clear the previous pill in this option group before marking the new
        // one. These inputs never actually end up :checked — .original-radios
        // and .custom-radios render the same id, so the label activates the
        // hidden original and the line below is undone straight away — which
        // leaves .selected-option as the only thing driving the active style.
        // Without this reset the class piles up and every size clicked stays
        // highlighted until the section re-render happens to wipe it.
        customRadio
          .closest('.custom-radios')
          ?.querySelectorAll('[type="radio"].selected-option')
          .forEach((radio) => radio.classList.remove('selected-option'));

        customRadio.checked = true;
        customRadio.classList.add('selected-option');
      }

      // Select the corresponding original radio
      var originalRadio = document.querySelector(
        `.full-width-main-product .original-radios [type="radio"][value="${selectedOptionVal}"]`,
      );
      if (originalRadio) {
        originalRadio.checked = true;
      }

      // Check if all options are selected
      var selectedOptions = document.querySelectorAll(
        '.full-width-main-product .original-radios [type="radio"]:checked',
      );
      //console.log(selectedOptions.length, numberOfOptions);
      if (selectedOptions.length === numberOfOptions) {
        // Trigger change event on the variant selector right away — the render
        // itself is already debounced downstream, so delaying here only added latency.
        var variantSelect = document.querySelector(
          '.full-width-main-product variant-selects',
        );
        if (variantSelect) {
          variantSelect.dispatchEvent(new Event('change'));
        }
      }
    });
  });

  // Auto-select the default variant for pants, driven by the product metafield
  // custom.pants_default_variant (format follows the admin variant title, e.g. "34 / 32" = Waist / Inseam).
  function applyPantsDefaultVariant() {
    var container = document.querySelector("product-info[id^='MainProduct-']");
    if (!container) return;

    try {
      var defaultStr = (container.dataset.defaultVariant || '').trim();
      if (!defaultStr) return;

      var variantSelect = container.querySelector('variant-selects');
      if (!variantSelect) return;

      var variantsNode = container.querySelector('[data-product-variants]') || document.querySelector('[data-product-variants]');
      var optionsNode = container.querySelector('[data-product-options]') || document.querySelector('[data-product-options]');
      if (!variantsNode || !optionsNode) return;

      var variants, optionNames;
      try {
        variants = JSON.parse(variantsNode.textContent);
        optionNames = JSON.parse(optionsNode.textContent);
      } catch (e) {
        return;
      }

      // Non-color options in order (Waist, Inseam)
      var targetOptions = [];
      optionNames.forEach(function (name, i) {
        if (!/colou?r/i.test(name)) {
          targetOptions.push({ name: name, key: 'option' + (i + 1) });
        }
      });
      if (!targetOptions.length) return;

      // Map target values in order (accepts both "34/32" and "34 / 32")
      var parts = defaultStr.split('/').map(function (s) { return s.trim(); });
      targetOptions.forEach(function (opt, k) { opt.target = parts[k]; });
      if (targetOptions.some(function (opt) { return opt.target == null || opt.target === ''; })) return;

      var available = variants.filter(function (v) { return v.available; });
      if (!available.length) return;

      // Exact match
      var chosen = available.find(function (variant) {
        return targetOptions.every(function (opt) {
          return String(variant[opt.key]) === String(opt.target);
        });
      });

      // Fallback: nearest available variant. Compare option by option in order
      // (Waist first, then Inseam): smaller absolute distance wins; ties prefer the smaller size.
      if (!chosen) {
        chosen = available.slice().sort(function (variantA, variantB) {
          for (var i = 0; i < targetOptions.length; i++) {
            var optionKey = targetOptions[i].key;
            var target = parseFloat(targetOptions[i].target);
            var distanceA = Math.abs(parseFloat(variantA[optionKey]) - target);
            var distanceB = Math.abs(parseFloat(variantB[optionKey]) - target);
            if (distanceA !== distanceB) return distanceA - distanceB;
          }
          // Same distance on every option: prefer the smaller size
          for (var j = 0; j < targetOptions.length; j++) {
            var optionKeyForTie = targetOptions[j].key;
            var sizeDiff = parseFloat(variantA[optionKeyForTie]) - parseFloat(variantB[optionKeyForTie]);
            if (sizeDiff !== 0) return sizeDiff;
          }
          return 0;
        })[0];
      }
      if (!chosen) return;

      // Tick radios per option fieldset, matched by option-name class to avoid the
      // hidden color fieldset and value collisions between Waist/Inseam
      var pillFieldsets = Array.prototype.slice.call(
        variantSelect.querySelectorAll('fieldset.product-form__input--pill')
      );

      targetOptions.forEach(function (opt) {
        var value = String(chosen[opt.key]);
        var cls = opt.name.toLowerCase();
        var fieldset = pillFieldsets.filter(function (f) { return f.classList.contains(cls); })[0];
        if (!fieldset) return;

        fieldset.querySelectorAll('.original-radios [type="radio"]').forEach(function (r) {
          r.checked = r.value === value;
        });
        fieldset.querySelectorAll('.custom-radios [type="radio"]').forEach(function (r) {
          var on = r.value === value;
          r.checked = on;
          r.classList.toggle('selected-option', on);
        });
        var label = fieldset.querySelector('[data-selected-value]');
        if (label) label.textContent = value;
      });

      // Resolve the variant through the existing pipeline (price/gallery/ATC/analytics)
      variantSelect.dispatchEvent(new Event('change'));
    } finally {
      // Always clear the pending flag (even on early return) to reveal the real selection
      container.removeAttribute('data-pants-default-pending');
    }
  }

  // Wait until variant-selects and product-form are upgraded before auto-selecting
  // (so the dispatched change isn't lost and no undefined method is called)
  function initPantsDefaultVariant() {
    var tries = 0;
    (function attempt() {
      var productInfo = document.querySelector("product-info[id^='MainProduct-']");
      var variantSelects = productInfo && productInfo.querySelector('variant-selects');
      var productForm = productInfo && productInfo.querySelector('product-form');
      var variantSelectsReady = variantSelects && typeof variantSelects.selectedOptionValues !== 'undefined';
      var productFormReady = !productForm || typeof productForm.handleErrorMessage === 'function';
      if (variantSelectsReady && productFormReady) {
        applyPantsDefaultVariant();
      } else if (tries++ < 30) {
        setTimeout(attempt, 100);
      } else if (productInfo) {
        productInfo.removeAttribute('data-pants-default-pending');
      }
    })();
  }

  if (!variantId) {
    initPantsDefaultVariant();
  } else {
    // URL already has ?variant=: the server selected the correct variant, just clear any leftover pending flag
    var productInfoWithVariant = document.querySelector("product-info[id^='MainProduct-']");
    if (productInfoWithVariant) productInfoWithVariant.removeAttribute('data-pants-default-pending');
  }
// });

// class DataLayerVariantFixer {
//   constructor(maxRetries = 200, interval = 50) {
//     this.retries = 0;
//     this.maxRetries = maxRetries;
//     this.interval = interval;
//     this.waitForDataLayer();
//   }

//   waitForDataLayer() {
//     if (!window.dataLayer || !window.dataLayer.push) {
//       if (this.retries++ < this.maxRetries) {
//         setTimeout(() => this.waitForDataLayer(), this.interval);
//       } else {
//         console.warn("DataLayer not found, stop trying.");
//       }
//       return;
//     }
//     this.overridePush();
//   }

//   getCurrentVariantId() {
//     const urlParams = new URLSearchParams(window.location.search);
//     const variantId = urlParams.get("variant");
//     if (variantId) return variantId;

//     const checkedRadio = document.querySelector(
//       ".original-radios [type='radio']:checked"
//     );
//     return checkedRadio ? checkedRadio.value : null;
//   }

//   getVariantById(id) {
//     try {
//       const node = document.querySelector("[data-product-variants]");
//       if (!node) return null;
//       const variants = JSON.parse(node.innerHTML);
//       return variants.find((v) => v.id == id) || null;
//     } catch (e) {
//       console.warn("Failed to parse variants", e);
//       return null;
//     }
//   }

//   overridePush() {
//     const variantsData = JSON.parse(
//       document.querySelector("[data-product-variants]").textContent
//     );

//     const optionsData = JSON.parse(
//       document.querySelector("[data-product-options]").textContent
//     );

//     const sizeIndex = optionsData.findIndex(opt => /size/i.test(opt));

//     const originalPush = window.dataLayer.push;
//     window.dataLayer.push = (...args) => {
//       const eventObj = args[0];
//       if (eventObj?.event === "dl_view_item") {
//         const product = eventObj.ecommerce?.detail?.products?.[0];
//         if (product) {
//           const currentId = this.getCurrentVariantId();
//           const currentVariant = currentId
//             ? variantsData.find(v => String(v.id) === String(currentId))
//             : null;

//           if (currentVariant) {
//             product.variant = currentVariant.title;
//             product.variant_id = String(currentVariant.id);

//             if (sizeIndex >= 0) {
//               product.item_category2 = currentVariant[`option${sizeIndex + 1}`] || "";
//             }
//           } else {
//             product.variant = "";
//             product.item_category2 = "";
//           }

//           const gender = document.getElementById("product-gender")?.dataset.gender || "Unisex";
//           product.item_category1 = gender;

//           const pdpTitle = document.querySelector("h1.product__title")?.innerText;
//           if (pdpTitle) {
//             product.name = pdpTitle.trim();
//           }
//         }
//         console.log("dl_view_item fixed:", eventObj);
//       }
//       return originalPush.apply(window.dataLayer, args);
//     };
//   }
// }

// new DataLayerVariantFixer();

if (typeof DataLayerVariantFixer === 'undefined') {
  class DataLayerVariantFixer {
    constructor(maxRetries = 200, interval = 50) {
      this.retries = 0;
      this.maxRetries = maxRetries;
      this.interval = interval;
      this.waitForDataLayer();
    }

    waitForDataLayer() {
      if (!window.dataLayer || !window.dataLayer.push) {
        if (this.retries++ < this.maxRetries) {
          setTimeout(() => this.waitForDataLayer(), this.interval);
        } else {
          console.warn("DataLayer not found, stop trying.");
        }
        return;
      }
      this.overridePush();
    }

    getCurrentVariantId() {
      const urlParams = new URLSearchParams(window.location.search);
      const variantId = urlParams.get("variant");
      if (variantId) return variantId;

      const checkedRadio = document.querySelector(
        ".original-radios [type='radio']:checked"
      );
      return checkedRadio ? checkedRadio.value : null;
    }

    getVariantById(id) {
      try {
        const node = document.querySelector("[data-product-variants]");
        if (!node) return null;
        const variants = JSON.parse(node.innerHTML);
        return variants.find((v) => v.id == id) || null;
      } catch (e) {
        console.warn("Failed to parse variants", e);
        return null;
      }
    }

    overridePush() {
      const variantsData = JSON.parse(
        document.querySelector("[data-product-variants]").textContent
      );

      const optionsData = JSON.parse(
        document.querySelector("[data-product-options]").textContent
      );

      const sizeIndex = optionsData.findIndex(opt => /size/i.test(opt));

      const originalPush = window.dataLayer.push;
      window.dataLayer.push = (...args) => {
        const eventObj = args[0];
        if (eventObj?.event === "dl_view_item") {
          const product = eventObj.ecommerce?.detail?.products?.[0];
          if (product) {
            const currentId = eventObj._explicitVariantId || this.getCurrentVariantId();
            const currentVariant = currentId
              ? variantsData.find(v => String(v.id) === String(currentId))
              : null;

            if (currentVariant) {
              product.variant = currentVariant.title;
              product.variant_id = String(currentVariant.id);

              if (sizeIndex >= 0) {
                product.item_category2 = currentVariant[`option${sizeIndex + 1}`] || "";
              }

              product.out_of_stock = !currentVariant.available;
            } else {
              product.variant = "";
              product.item_category2 = "";
              product.out_of_stock = null;
            }

            const gender = document.getElementById("product-gender")?.dataset.gender || "Unisex";
            product.item_category1 = gender;

            const pdpTitle = document.querySelector(".product__title h1")?.innerText;
            if (pdpTitle) {
              product.name = pdpTitle.trim();
            }
          }
          //console.log("dl_view_item fixed:", eventObj);
        }
        return originalPush.apply(window.dataLayer, args);
      };

      // Push a new dl_view_item whenever the user selects a variant
      subscribe(PUB_SUB_EVENTS.variantChange, ({ data: { variant } }) => {
        if (!variant) return;
        const templateEvent = window.dataLayer.find(e => e.event === 'dl_view_item');
        if (!templateEvent) return;
        const templateProduct = templateEvent.ecommerce?.detail?.products?.[0];
        if (!templateProduct) return;
        window.dataLayer.push({
          event: 'dl_view_item',
          _explicitVariantId: String(variant.id),
          ecommerce: {
            detail: {
              products: [{ ...templateProduct, variant_id: String(variant.id) }],
            },
          },
        });
      });
    }
  }

  window.DataLayerVariantFixer = DataLayerVariantFixer;
  new DataLayerVariantFixer();
}

// ---------------------------------------------------------------------------
// OutOfStockTracker – nutrition template mirror
// Same logic as product-info.js; guard prevents double-instantiation when
// both scripts are loaded on the same page.
// ---------------------------------------------------------------------------
if (typeof OutOfStockTracker === 'undefined') {
  class OutOfStockTracker {
    constructor() {
      this.fired = false;
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.track());
      } else {
        this.track();
      }
    }

    track() {
      if (this.fired) return;

      const variantsNode = document.querySelector('[data-product-variants]');
      const optionsNode  = document.querySelector('[data-product-options]');
      if (!variantsNode || !optionsNode) return;

      let variants, options;
      try {
        variants = JSON.parse(variantsNode.textContent);
        options  = JSON.parse(optionsNode.textContent);
      } catch (e) {
        console.warn('OutOfStockTracker: failed to parse product data', e);
        return;
      }

      const sizeIndex  = options.findIndex(opt => /size/i.test(opt));
      const colorIndex = options.findIndex(opt => /colou?r/i.test(opt));
      if (sizeIndex < 0) return;

      const sizeKey  = `option${sizeIndex + 1}`;
      const colorKey = colorIndex >= 0 ? `option${colorIndex + 1}` : null;

      // A size is OOS only when ALL its variants are unavailable
      const sizeMap = {};
      variants.forEach(v => {
        const size = v[sizeKey];
        if (!size) return;
        if (!Object.prototype.hasOwnProperty.call(sizeMap, size)) sizeMap[size] = false;
        if (v.available) sizeMap[size] = true;
      });

      const sizeSort = (a, b) => parseFloat(a) - parseFloat(b) || a.localeCompare(b);
      const allSizes = Object.keys(sizeMap).sort(sizeSort);
      const oosSizes = allSizes.filter(size => !sizeMap[size]);

      if (oosSizes.length === 0) return;

      const itemId     = document.querySelector('[data-product-id]')?.dataset?.productId || '';
      const itemName   = document.querySelector('.product__title h1')?.innerText?.trim()  || '';
      const itemColor  = colorKey ? (variants[0]?.[colorKey] || '') : '';
      const itemGender = document.getElementById('product-gender')?.dataset?.gender || 'Unisex';

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event:              'out_of_stock',
        item_id:            String(itemId),
        item_name:          itemName,
        item_color:         itemColor,
        item_gender:        itemGender,
        available_sizes:    allSizes.length,
        out_of_stock_sizes: {
          sizes: oosSizes,
          count: oosSizes.length
        }
      });

      this.fired = true;
    }
  }

  window.OutOfStockTracker = OutOfStockTracker;
  new OutOfStockTracker();
}